
export class PasswordExtraField {
    id: string;
    data: string;
    name: string;
    type: string;
    passwordId: number;
}